import * as yup from 'yup';

export const travelInsuranceInitialValues = {
  travelInsuranceCost: null,
  travelInsuranceComments: '',
};

export const travelInsuranceValidationSchema = yup.object().shape({
  travelInsuranceCost: yup
    .number()
    .nullable()
    .transform((_, val) => (val === '' ? null : Number(val)))
    .required('Costs is required.')
    .typeError('Costs must be a number')
    .moreThan(0, 'Costs must be greater than 0'),
  travelInsuranceComments: yup.string(),
});
